// SPEC-COLLECTION-HISTORY-FILTER-AND-ROWCAP-FIX-01 (D-395) ITEM_3 (A案) — ブランドまとめ方の唯一の定義。
//   データ(stores.brand_name)は分けたまま保持し、画面の選択肢側でまとめる。まとめ方はこの1ファイルにのみ置き、
//   画面ごとに書かない。将来まとめ方を変えるときはここだけ見ればよい。
//
// key = 画面に出す代表ブランド名 / value = それに含める実 brand_name 群。
//   例: ドン・キホーテ を選ぶと MEGAドン・キホーテ の店舗も含めて表示する(AC6)。
export const BRAND_GROUPS = {
  'ドン・キホーテ': ['ドン・キホーテ', 'MEGAドン・キホーテ'],
};

// 実 brand_name → 画面表示の代表ブランド(どのグループにも属さなければ自分自身)。
export function canonicalBrand(brandName) {
  for (const rep of Object.keys(BRAND_GROUPS)) {
    if (BRAND_GROUPS[rep].includes(brandName)) return rep;
  }
  return brandName;
}

// 画面で選んだ代表ブランド → フィルタに使う実 brand_name 群(グループなら全メンバー、単体なら自分だけ)。
export function brandNamesForFilter(repBrand) {
  return BRAND_GROUPS[repBrand] ? [...BRAND_GROUPS[repBrand]] : [repBrand];
}

// 実 brand_name の配列 → 画面に出す代表ブランドの重複なし一覧(初出順)。null/空は除外。
export function brandOptions(brandNames) {
  const out = [];
  for (const b of brandNames ?? []) {
    if (b == null || b === '') continue;
    const rep = canonicalBrand(b);
    if (!out.includes(rep)) out.push(rep);
  }
  return out;
}
